import type { UseCase } from '@/core/shared'
import type { AccessConfigRepository } from '../domain'

export const createAccessConfig: UseCase<AccessConfigRepository, 'createAccessConfig'> = (repository) => {
  return async (createAccessConfig) => {
    return await repository.createAccessConfig(createAccessConfig)
  }
}
